const LiteralCode = {
  'ContractStatus.code': {
    es_PY: 'Estado'
  },
  'ContractType.name': {
    es_PY: 'Tipo'
  },
  'CustomerContract.itemName': {
    es_PY: 'Nombre'
  },
  'CustomerType.code': {
    es_PY: 'Tipo'
  },
  '${contractCodePrefix}${contractCode}': {
    es_PY: 'Nº'
  },
  "${'CL'}${customerCode}": {
    es_PY: 'Código'
  },
  email: {
    es_PY: 'Email'
  },
  action: {
    es_PY: 'Acción'
  },
  customerTermStatusId: {
    es_PY: 'Estado'
  },
  companyHeadquarterId: {
    es_PY: 'Sede'
  },
  all: {
    es_PY: 'Todos'
  },
  'CompanyHeadquarter.name': {
    es_PY: 'Sede'
  },
  companyHeadquarterListId: {
    es_PY: 'Sede'
  },
  businessName: {
    es_PY: 'Razón social'
  },
  salePrice: {
    es_PY: 'Precio de venta'
  },
  balance: {
    es_PY: 'Saldo'
  },
  code: {
    es_PY: 'Código'
  },
  productCategoryId: {
    es_PY: 'Categoría'
  },
  productSubcategoryId: {
    es_PY: 'Subcategoría'
  },
  customerCode: {
    es_PY: 'Código cliente'
  },
  contractTypeId: {
    es_PY: 'Tipo de contrato'
  },
  customerTypeId: {
    es_PY: 'Tipo de cliente'
  },
  isFleet: {
    es_PY: 'Es cliente de flota'
  },
  contractCode: {
    es_PY: 'Código de contrato'
  },
  pending_approval: {
    es_PY: 'PENDIENTE DE APROBACIÓN'
  },
  cancelled: {
    es_PY: 'CANCELADO'
  },
  rejected: {
    es_PY: 'RECHAZADO'
  },
  status: {
    es_PY: 'Estado'
  },
  type: {
    es_PY: 'Tipo'
  },
  name: {
    es_PY: 'Nombre'
  },
  appUser: {
    es_PY: 'Usuario APP'
  },
  firstname: {
    es_PY: 'Nombre'
  },
  surnames: {
    es_PY: 'Apellidos'
  },
  address: {
    es_PY: 'Dirección'
  },
  department: {
    es_PY: 'Departamento'
  },
  city: {
    es_PY: 'Ciudad'
  },
  postalCode: {
    es_PY: 'Código postal'
  },
  phone1: {
    es_PY: 'Teléfono 1'
  },
  phone2: {
    es_PY: 'Teléfono 2'
  },
  relationship: {
    es_PY: 'Relación'
  },
  hasUser: {
    es_PY: 'Usuario para acceso a plataforma'
  },
  document: {
    es_PY: 'Documento'
  },
  beginDate: {
    es_PY: 'Fecha de inicio'
  },
  contract_code_already_exists: {
    es_PY: 'Ya existe el código de contrato'
  },
  cant_inactive_contract_has_pending_terms: {
    es_PY:
      'No se puede de dar de baja el contrato ya que tiene cuotas pendientes de pago'
  },
  'billToCustomerContact.phone1': {
    es_PY: 'Tlf. facturación'
  },
  'MoneyCollectionCustomerContact.document': {
    es_PY: 'Cobranzas'
  },
  '${MoneyCollectionCustomerContact.firstname}${MoneyCollectionCustomerContact.surnames}|MoneyCollectionCustomerContact.firstname': {
    es_PY: 'Cobranzas'
  },
  'MoneyCollectionCustomerContact.phone1': {
    es_PY: 'Tlf. Cobranzas'
  },
  'PromisePayment.promiseDate': {
    es_PY: 'Fecha compromiso'
  },
  hasValidPromisePayment: {
    es_PY: 'Compromiso válido'
  },
  renewalDate: {
    es_PY: 'Fecha de renovación'
  },
  number: {
    es_PY: 'Nº'
  },
  identity_card: {
    es_PY: 'C.I.'
  },
  vehicle_identity_card: {
    es_PY: 'C.Verde'
  },
  activationTypeId: {
    es_PY: 'Tipo de alta'
  },
  installationAddress: {
    es_PY: 'Dirección instalación'
  },
  plannedInstallationDate: {
    es_PY: 'Fecha instalación planificada'
  },
  hasSellerUnmanagedSignaturePenaltyFee: {
    es_PY: 'Multa por no gestionar firma'
  },
  hasReferralComission: {
    es_PY: 'Descuento referido'
  },
  brand: {
    es_PY: 'Marca'
  },
  model: {
    es_PY: 'Modelo'
  },
  year: {
    es_PY: 'Año'
  },
  comments: {
    es_PY: 'Comentarios'
  },
  newComment: {
    es_PY: 'Nuevo comentario'
  },
  internalComments: {
    es_PY: 'Comentarios internos'
  },
  duration: {
    es_PY: 'Duración'
  },
  totalDuration: {
    es_PY: 'Duración total (meses)'
  },
  totalPrice: {
    es_PY: 'Coste total'
  },
  costPrice: {
    es_PY: 'Costo'
  },
  rest: {
    es_PY: 'Restante'
  },
  createdAt: {
    es_PY: 'Fecha de creación'
  },
  updatedAt: {
    es_PY: 'Fecha mod.'
  },
  beginAt: {
    es_PY: 'Fecha inicio'
  },
  scheduledPaymentDate: {
    es_PY: 'Fecha pago planificada'
  },
  productName: {
    es_PY: 'Producto'
  },
  price: {
    es_PY: 'Precio'
  },
  contractCodePrefix: {
    es_PY: 'Prefijo contrato'
  },
  promoDuration: {
    es_PY: 'Duración promo (meses)'
  },
  discountPercentage: {
    es_PY: 'Descuento %'
  },
  installationCost: {
    es_PY: 'Coste instalación'
  },
  installationTerms: {
    es_PY: 'Nº cuotas instalación'
  },
  serviceList: {
    es_PY: 'Servicios'
  },
  itemName: {
    es_PY: 'Chapa'
  },
  identification: {
    es_PY: 'Chasis'
  },
  productList: {
    es_PY: 'Productos'
  },
  contractTypeIdAfterExpiration: {
    es_PY: 'Tipo de contrato tras expiración'
  },
  holder: {
    es_PY: 'Titular'
  },
  family: {
    es_PY: 'Familiar'
  },
  son: {
    es_PY: 'Hijo'
  },
  friend: {
    es_PY: 'Amigo'
  },
  wife: {
    es_PY: 'Esposa'
  },
  brother: {
    es_PY: 'Hermano'
  },
  grandmother: {
    es_PY: 'Abuela'
  },
  grandfather: {
    es_PY: 'Abuelo'
  },
  employee: {
    es_PY: 'Empleado'
  },
  other: {
    es_PY: 'Otro'
  },
  not_interesed: {
    es_PY: 'NO INTERESADO'
  },
  interesed: {
    es_PY: 'INTERESADO'
  },
  _0_pending_contact: {
    es_PY: 'PENDIENTE DE CONTACTO'
  },
  _1_contact_planned: {
    es_PY: 'CONTACTO PLANIFICADO'
  },
  _0_active_pending_contact: {
    es_PY: 'ALTA - PENDIENTE DE CONTACTO'
  },
  _1_active_contact_planned: {
    es_PY: 'ALTA - CONTACTO PLANIFICADO'
  },
  in_process: {
    es_PY: 'EN PROCESO'
  },
  activate: {
    es_PY: 'ALTA'
  },
  contacted: {
    es_PY: 'CONTACTADO'
  },
  active: {
    es_PY: 'ALTA'
  },
  finalized: {
    es_PY: 'CONCRETADO'
  },
  active_pending_payment: {
    es_PY: 'ALTA (PENDIENTE DE PAGO)'
  },
  active_reinstallation: {
    es_PY: 'ALTA - REINSTALACIÓN'
  },
  active_holder_change: {
    es_PY: 'ALTA - CAMBIO TITULAR'
  },
  inactive: {
    es_PY: 'BAJA'
  },
  temporary_suspension: {
    es_PY: 'SUSPENSIÓN TEMPORAL'
  },
  service_cut: {
    es_PY: 'CORTE DE SERVICIO'
  },
  service_and_billing_cut: {
    es_PY: 'CORTE DE SERVICIO + FACTURACIÓN'
  },
  inactive_with_notice: {
    es_PY: 'BAJA CON PREAVISO'
  },
  work_sheet: {
    es_PY: 'HOJA DE TRABAJO'
  },
  promissory_note: {
    es_PY: 'PAGARÉ'
  },
  annex: {
    es_PY: 'ANEXO'
  },
  assessment: {
    es_PY: 'RELEVAMIENTO'
  },
  company_charter: {
    es_PY: 'CONSTITUCIÓN SOCIEDAD'
  },
  signatories_register: {
    es_PY: 'CÉDULA FIRMANTES'
  },
  meeting_minute: {
    es_PY: 'ACTA ASAMBLEA'
  },
  ruc: {
    es_PY: 'RUC'
  },
  billing_order: {
    es_PY: 'ORDEN DE FACTURACIÓN'
  },
  pending_installation: {
    es_PY: 'APROBADO - INSTALACIÓN PENDIENTE'
  },
  inactive_pending_uninstallation: {
    es_PY: 'BAJA - DESINSTALACIÓN PENDIENTE'
  },
  inactive_reinstallation: {
    es_PY: 'BAJA - REINSTALACIÓN'
  },
  inactive_holder_change: {
    es_PY: 'BAJA - CAMBIO TITULAR'
  },
  searchCustomer: {
    es_PY: 'Buscar cliente'
  },
  contractStatusId: {
    es_PY: 'Estado'
  },
  birthdate: {
    es_PY: 'Fecha de nacimiento'
  },
  company: {
    es_PY: 'Empresa'
  },
  individual: {
    es_PY: 'Particular'
  },
  public_employee: {
    es_PY: 'Funcionario'
  },
  fleet: {
    es_PY: 'Flota'
  },
  fieldNumeric: {
    es_PY: 'El campo debe ser numérico'
  },
  fieldRequired: {
    es_PY: 'Campo obligatorio'
  },
  pending: {
    es_PY: 'PENDIENTE'
  },
  new: {
    es_PY: 'NUEVO'
  },
  reinstallation: {
    es_PY: 'REINSTALACIÓN'
  },
  holder_change: {
    es_PY: 'CAMBIO DE TITULAR'
  },
  locatorTypeId: {
    es_PY: 'Tipo de localizador'
  },
  vehicle: {
    es_PY: 'VEHÍCULO'
  },
  vehicle_small: {
    es_PY: 'VEHÍCULO PEQUEÑO'
  },
  stock: {
    es_PY: 'Depósito'
  },
  installed: {
    es_PY: 'Instalado'
  },
  installer: {
    es_PY: 'Instalador'
  },
  selled: {
    es_PY: 'Vendido'
  },
  laboratory: {
    es_PY: 'Laboratorio'
  },
  review: {
    es_PY: 'En revisión'
  },
  location: {
    es_PY: 'Ubicación'
  },
  productTypeId: {
    es_PY: 'Tipo de producto'
  },
  motorcycle: {
    es_PY: 'MOTO'
  },
  pickup: {
    es_PY: 'CAMIONETA ABIERTA'
  },
  pickup_closed: {
    es_PY: 'CAMIONETA CERRADA'
  },
  truck: {
    es_PY: 'CAMIÓN TRACTO'
  },
  truck_big: {
    es_PY: 'CAMIÓN GRANDE'
  },
  truck_small: {
    es_PY: 'CAMIÓN PEQUEÑO'
  },
  tractor: {
    es_PY: 'TRACTOR'
  },
  truck_tanker: {
    es_PY: 'CAMIÓN CISTERNA'
  },
  briefcase: {
    es_PY: 'MALETÍN'
  },
  holderCustomerContactId: {
    es_PY: 'Contacto titular'
  },
  beneficiaryCustomerContactId: {
    es_PY: 'Contacto beneficiario'
  },
  billToCustomerContactId: {
    es_PY: 'Contacto facturación'
  },
  moneyCollectionCustomerContactId: {
    es_PY: 'Contacto cobranzas'
  },
  debit_sheet: {
    es_PY: 'Débito/BNF'
  },
  sworn_declaration: {
    es_PY: 'Declaración jurada'
  },
  directives: {
    es_PY: 'Directivas'
  },
  hasPendingDocuments: {
    es_PY: 'Documentos'
  },
  paymentTypeCode: {
    es_PY: 'Tipo de pago'
  },
  pending_deposit_note: {
    es_PY: 'PENDIENTE BOLETA'
  },
  pending_validation: {
    es_PY: 'PENDIENTE DE VALIDACIÓN'
  },
  validated: {
    es_PY: 'VALIDADO'
  },
  registeredAmount: {
    es_PY: 'Monto declarado'
  },
  registeredDifferenceAmount: {
    es_PY: 'Diferencia de monto'
  },
  bank_deposit_note_0: {
    es_PY: 'BOLETA DE INGRESO EN BANCO'
  },
  bank_deposit_note_1: {
    es_PY: 'BOLETA DE INGRESO EN BANCO (2)'
  },
  bank_deposit_note_2: {
    es_PY: 'BOLETA DE INGRESO EN BANCO (3)'
  },
  bank_deposit_note_3: {
    es_PY: 'BOLETA DE INGRESO EN BANCO (4)'
  },
  bank_deposit_note_4: {
    es_PY: 'BOLETA DE INGRESO EN BANCO (5)'
  },
  depositRegisteredAt: {
    es_PY: 'Fecha depósito'
  },
  totalAmount: {
    es_PY: 'Monto total'
  },
  depositNumber: {
    es_PY: 'Nº boleta'
  },
  dailyCashClosureCode: {
    es_PY: 'ID'
  },
  depositAmount: {
    es_PY: 'Monto boleta'
  },
  companyBankAccountId: {
    es_PY: 'Cuenta bancaria'
  },
  '${UserRegister.firstname}${UserRegister.surnames}': {
    es_PY: 'Usuario registro'
  },
  '${UserClose.firstname}${UserClose.surnames}': {
    es_PY: 'Usuario validación'
  },
  '${UserCreator.firstname}${UserCreator.surnames}': {
    es_PY: 'Usuario creación'
  },
  '${EmployeeCreator.firstname}${EmployeeCreator.surnames}': {
    es_PY: 'Empleado creación'
  },
  inactive_with_notice_sheet: {
    es_PY: 'Nota rescisión'
  },
  contactPlannedAt: {
    es_PY: 'Fecha de contacto planificada'
  },
  uninstallation_note: {
    es_PY: 'Nota desinstalación'
  },
  budget_0: {
    es_PY: 'Presupuesto 1'
  },
  budget_1: {
    es_PY: 'Presupuesto 2'
  },
  budget_2: {
    es_PY: 'Presupuesto 3'
  },
  budget_3: {
    es_PY: 'Presupuesto 4'
  },
  informconf: {
    es_PY: 'informconf'
  },
  directives1CustomerContactId: {
    es_PY: 'Contacto directivas 1'
  },
  directives2CustomerContactId: {
    es_PY: 'Contacto directivas 2'
  },
  directives3CustomerContactId: {
    es_PY: 'Contacto directivas 3'
  },
  directives4CustomerContactId: {
    es_PY: 'Contacto directivas 4'
  },
  directives5CustomerContactId: {
    es_PY: 'Contacto directivas 5'
  },
  info1CustomerContactId: {
    es_PY: 'Contacto solicitar info 1'
  },
  info2CustomerContactId: {
    es_PY: 'Contacto solicitar info 2'
  },
  info3CustomerContactId: {
    es_PY: 'Contacto solicitar info 3'
  },
  info4CustomerContactId: {
    es_PY: 'Contacto solicitar info 4'
  },
  info5CustomerContactId: {
    es_PY: 'Contacto solicitar info 5'
  },
  sellerEmployeeId: {
    es_PY: 'Vendedor'
  },
  '${Seller.firstname}${Seller.surnames}': {
    es_PY: 'Vendedor'
  },
  installationTechnicianEmployeeId: {
    es_PY: 'Técnico instalador'
  },
  sells: {
    es_PY: 'VENTAS'
  },
  sellerComission: {
    es_PY: 'Comisión vendedor'
  },
  referralComission: {
    es_PY: 'Descuento referido'
  },
  contractTypeReferralComission: {
    es_PY: 'Referido'
  },
  unmanagedSignaturePenaltyFee: {
    es_PY: 'Multa por no gestionar firma'
  },
  installation_technician: {
    es_PY: 'TÉCNICO INSTALADOR'
  },
  contractBeginDate: {
    es_PY: 'Fecha de inicio contrato'
  },
  paymentTypeId: {
    es_PY: 'Método de pago'
  },
  MoneyCollectionCustomerContactPaymentTypeList: {
    es_PY: 'Método de pago'
  },
  date: {
    es_PY: 'Fecha'
  },
  reference: {
    es_PY: 'Referencia'
  },
  'PaymentStatus.code': {
    es_PY: 'Estado'
  },
  'PaymentMode.code': {
    es_PY: 'Tipo'
  },
  'PaymentType.code': {
    es_PY: 'Método de pago'
  },
  amount: {
    es_PY: 'Monto'
  },
  vatAmount: {
    es_PY: 'Total IVA'
  },
  contractTypeSellerComission: {
    es_PY: 'Comisión vendedor'
  },
  UnmanagedSignaturePenaltyFee: {
    es_PY: 'Multa gestión firma'
  },
  invoice: {
    es_PY: 'Factura'
  },
  credit_note: {
    es_PY: 'Nota de crédito'
  },
  documentStamp: {
    es_PY: 'Timbrado documento'
  },
  printStamp: {
    es_PY: 'Timbrado imprenta'
  },
  numberingFrom: {
    es_PY: 'Numeración desde'
  },
  numberingTo: {
    es_PY: 'Numeración hasta'
  },
  validityFrom: {
    es_PY: 'Vigencia desde'
  },
  validityTo: {
    es_PY: 'Vigencia hasta'
  },
  'CustomerTermStatus.code': {
    es_PY: 'Estado'
  },
  pending_invoice: {
    es_PY: 'FACTURA POR GENERAR'
  },
  pending_payment: {
    es_PY: 'PENDIENTE DE PAGO'
  },
  paid: {
    es_PY: 'PAGADO'
  },
  partial_payment: {
    es_PY: 'PAGO PARCIAL'
  },
  promise: {
    es_PY: 'COMPROMISO DE PAGO'
  },
  customer: {
    es_PY: 'CLIENTE'
  },
  detail: {
    es_PY: 'Detalle'
  },
  'CustomerInvoiceStatus.code': {
    es_PY: 'Estado'
  },
  nextBillPeriod: {
    es_PY: 'Cobro en siguiente mes'
  },
  'HeadquarterCustomer.businessName': {
    es_PY: 'Cliente'
  },
  'HeadquarterCustomer.businessName,LINK:/app/customers/:headquarterCustomerId': {
    es_PY: 'Cliente'
  },
  "${'CL'}${HeadquarterCustomer.customerCode}": {
    es_PY: 'Cód. Cliente'
  },
  neighborhood: {
    es_PY: 'Barrio'
  },
  atc: {
    es_PY: 'ATC'
  },
  customer_already_exists: {
    es_PY: 'Ya existe un cliente con el mismo documento'
  },
  cant_update_contract_invalid_contract_status: {
    es_PY:
      'No se puede actualizar el contrato, ya que el estado que intenta actualizar no está permitido con el estado actual del contrato'
  },
  document_type: {
    es_PY: 'Tipo de documento'
  },

  'Locator already exists': {
    es_PY:
      'No se creó en DomoSmart, ya existe el mismo nº de contrato. Revise que sea correcto.'
  },
  'billToCustomerContact.zoneCode': {
    es_PY: 'Zona'
  },
  additionalServiceContractTypeListId: {
    es_PY: 'Servicios recurrentes'
  },
  billToCustomerContactDocument: {
    es_PY: 'Documento'
  },
  cash_money_collector: {
    es_PY: 'Efectivo (Cobrador)'
  },
  cash_box: {
    es_PY: 'Efectivo (Ventanilla)'
  },
  debit: {
    es_PY: 'Débito'
  },
  bnf_debit: {
    es_PY: 'Débito BNF'
  },
  bnf_cash: {
    es_PY: 'Efectivo BNF'
  },
  tigo_transfer: {
    es_PY: 'Giro Tigo'
  },
  salary_discount: {
    es_PY: 'Descuento de salario'
  },
  to_contact: {
    es_PY: 'Contactar'
  },
  hasPaymentsValidated: {
    es_PY: 'Pago validado'
  },
  invoice_reception: {
    es_PY: 'Entrega de facturas'
  },
  yes: {
    es_PY: 'SÍ'
  },
  no: {
    es_PY: 'NO'
  },
  color: {
    es_PY: 'Color'
  },
  description: {
    es_PY: 'Descripción'
  },
  paymentTypeListId: {
    es_PY: 'Métodos de pago'
  },
  PaymentTypeList: {
    es_PY: 'Método de pago'
  },
  white: {
    es_PY: 'Blanco'
  },
  black: {
    es_PY: 'Negro'
  },
  red: {
    es_PY: 'Rojo'
  },
  blue: {
    es_PY: 'Azul'
  },
  yellow: {
    es_PY: 'Amarillo'
  },
  green: {
    es_PY: 'Verde'
  },
  gray: {
    es_PY: 'Gris'
  },
  beige: {
    es_PY: 'Beige'
  },
  brown: {
    es_PY: 'Marrón'
  },
  burgundy: {
    es_PY: 'Bordo'
  },
  cyan: {
    es_PY: 'Cian'
  },
  lilac: {
    es_PY: 'Lila'
  },
  mustard: {
    es_PY: 'Mostaza'
  },
  orange: {
    es_PY: 'Naranja'
  },
  pink: {
    es_PY: 'Rosa'
  },
  teal: {
    es_PY: 'Verde azulado'
  },
  bank_transfer: {
    es_PY: 'Transferencia'
  },
  bank_check: {
    es_PY: 'Cheque'
  },
  pos: {
    es_PY: 'P.O.S'
  },
  invoiceNumber: {
    es_PY: 'Nº Factura'
  },
  invoiceStampingNumber: {
    es_PY: 'Timbrado'
  },
  moneyCollectionEmployeeId: {
    es_PY: 'Cobrador'
  },
  customerContactId: {
    es_PY: 'Recibido de'
  },
  money_collection: {
    es_PY: 'COBRANZAS'
  },
  invoiceAmount: {
    es_PY: 'Monto factura'
  },
  userId: {
    es_PY: 'Usuario'
  },
  userFullName: {
    es_PY: 'Usuario'
  },
  invoice_already_paid: {
    es_PY:
      'No puede registrarse otro pago. La factura ya ha sido pagada totalmente con anterioridad'
  },
  invoice_not_found: {
    es_PY: 'No se puede registrar el pago: Factura no encontrada'
  },
  contract_not_expired: {
    es_PY: 'El contrato no puede renovarse ya que no ha vencido'
  },
  datetime: {
    es_PY: 'Fecha'
  },
  zoneCode: {
    es_PY: 'Código de zona'
  },
  latitude: {
    es_PY: 'Latitud'
  },
  longitude: {
    es_PY: 'Longitud'
  },
  holder_already_exists: {
    es_PY: 'Ya existe un contacto titular.'
  },
  "{{dateFormat(date, 'MMMM')}}|date": {
    es_PY: 'Mes'
  },
  '${billToCustomerContact.firstname}${billToCustomerContact.surnames}|billToCustomerContact.firstname': {
    es_PY: 'Facturación'
  },
  '${BillingCustomerContact.firstname}${BillingCustomerContact.surnames}|BillingCustomerContact.firstname': {
    es_PY: 'Facturación'
  },
  'BillingCustomerContact.document': {
    es_PY: 'Documento'
  },
  'CustomerContact.document': {
    es_PY: 'Documento'
  },
  'billToCustomerContact.document': {
    es_PY: 'Documento'
  },
  '${Employee.firstname}${Employee.surnames}': {
    es_PY: 'Empleado'
  },
  '${User.firstname}${User.surnames}': {
    es_PY: 'Usuario'
  },
  '${User.firstname}${User.surnames}${User.email}': {
    es_PY: 'Usuario/Email'
  },
  customerContractId: {
    es_PY: 'Contrato'
  },
  barCode: {
    es_PY: 'Código de barras'
  },
  manufacturer: {
    es_PY: 'Fabricante'
  },
  units: {
    es_PY: 'Cantidad'
  },
  expirationDate: {
    es_PY: 'Vencimiento'
  },
  serial: {
    es_PY: 'Nº serie'
  },
  InventoryIdentification: {
    es_PY: 'Identificador/IMEI'
  },
  'ProductType.name': {
    es_PY: 'Tipo producto'
  },
  overpayment: {
    es_PY: 'El pago no puede ser mayor al monto restante'
  },
  promise_payment_already_exists: {
    es_PY: 'Ya existe un compromiso de pago para la factura'
  },
  credit_note_payment_already_exists: {
    es_PY: 'Ya existe una nota de crédito para la factura'
  },
  promise_date_cant_be_lower_than_maximum_payment_date: {
    es_PY:
      'La fecha de compromiso debe ser mayor a la fecha límite de pago (día 17)'
  },
  'MoneyCollectionCustomerContact.paymentTypeNameList|MoneyCollectionCustomerContact.paymentTypeListId': {
    es_PY: 'Tipo de pago'
  },
  promise_date_cant_be_greater_than_next_month_maximum_payment_date: {
    es_PY:
      'La fecha de compromiso debe ser menor a la fecha límite de pago (menor a 17 del mes siguiente)'
  },
  minimum_payment_required: {
    es_PY: 'El monto no cumple el mínimo requerido'
  },
  preferredPaymentDay: {
    es_PY: 'Día de pago preferente'
  },
  'MoneyCollectionCustomerContact.preferredPaymentDay': {
    es_PY: 'Día de pago preferente'
  },
  'MoneyCollectionCustomerContact.comments': {
    es_PY: 'Comentarios contacto'
  },
  'monthNameTermList|date': {
    es_PY: 'Mes'
  },
  'monthNameTermList|datetime': {
    es_PY: 'Mes'
  },
  '${CustomerContract.contractCodePrefix}${CustomerContract.contractCode}': {
    es_PY: 'Cód. Contrato'
  },
  paymentModeId: {
    es_PY: 'Tipo'
  },
  prepayment: {
    es_PY: 'Pago único por adelantado'
  },
  promiseDate: {
    es_PY: 'Fecha compromiso de pago'
  },
  renew_contract: {
    es_PY: 'RENOVACIÓN DE CONTRATO'
  },
  contract_activation: {
    es_PY: 'CONTRATO Y COMMODATO'
  },
  inactive_contract: {
    es_PY: 'BAJA DE CONTRATO'
  },
  inactive_with_notice_contract: {
    es_PY: 'BAJA CON PREAVISO DE CONTRATO'
  },
  inactive_demo_contract: {
    es_PY: 'BAJA DE CONTRATO DEMO'
  },
  change_contract_status_to_service_and_billing_cut: {
    es_PY: 'CORTE DE SERVICIO + FACTURACIÓN'
  },
  change_contract_status_to_service_cut: {
    es_PY: 'CORTE DE SERVICIO'
  },
  reactivate_contract: {
    es_PY: 'REACTIVACIÓN DE CONTRATO'
  },
  employeeId: {
    es_PY: 'Empleado'
  },
  current_invoice_stamp_not_found: {
    es_PY: 'No se generó la factura, ya que no se encontró timbrado vigente.'
  },
  validationStatus: {
    es_PY: 'Estado de validación'
  },
  validated_payment: {
    es_PY: 'PAGO VALIDADO'
  },
  sendInvoiceEmail: {
    es_PY: 'Enviar factura por email'
  },
  payment_type_not_cancellable: {
    es_PY: 'El tipo de pago no puede ser cancelado'
  },
  cancel_payment: {
    es_PY: 'PAGO CANCELADO'
  },
  fromName: {
    es_PY: 'Nº'
  },
  text: {
    es_PY: 'Mensaje'
  },
  viewedAt: {
    es_PY: 'Visto a las'
  },
  'metadata.contactFullName': {
    es_PY: 'Contacto'
  },
  'metadata.customerBusinessName': {
    es_PY: 'Cód. Cliente'
  },
  'metadata.customerCode': {
    es_PY: 'Cód. Cliente'
  },
  outbound: {
    es_PY: 'Saliente'
  },
  inbound: {
    es_PY: 'Entrante'
  },
  origin: {
    es_PY: 'Origen'
  },
  invoice_number_already_exists: {
    es_PY: 'El número de factura ya existe'
  },
  invalid_invoice_number: {
    es_PY: 'El número de factura no es válido'
  }
};

const t = (literalCode, langCountryCode = 'es_PY') => {
  const translation =
    LiteralCode[literalCode] && LiteralCode[literalCode][langCountryCode]
      ? LiteralCode[literalCode][langCountryCode]
      : undefined;

  return translation;
};

module.exports = {
  LiteralCode,
  t
};
